import React, { useState } from "react";
import {
  Box,
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
  withStyles,
} from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";

interface ActionMenuComponentProps {
  items: any[];
}

const StyledMenu = withStyles({
  paper: {
    border: "1px solid var(--border) !important",
    boxShadow: "var(--shadow) !important",
    borderRadius: "12px !important",
    overflow: "hidden !important",
    minWidth: "12rem !important",
    padding: ".5rem",
    "& .MuiMenu-list": {
      padding: "0 !important",
    },
    "& .MuiMenuItem-root": {
      borderRadius: "6px !important",
      padding: "5px 15px !important",
      "&:hover": {
        backgroundColor: "var(--gray-bg) !important",
      },
    },
  },
})((props: any) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
));

const ActionMenuComponent: React.FC<ActionMenuComponentProps> = ({
  items = [],
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleItemClick = (action: any) => {
    handleClose();
    action?.();
  };

  return (
    <Box>
      <IconButton
        aria-controls="course-menu"
        aria-haspopup="true"
        onClick={handleMenuClick}
        style={{ padding: "5px", cursor: "pointer" }}
      >
        <MoreVertIcon />
      </IconButton>
      <StyledMenu
        id="course-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {items.map((item, index) => (
          <MenuItem
            key={index}
            onClick={() => handleItemClick(item.onClick)}
            disabled={item.disabled ?? false}
          >
            <ListItemText primary={item.label} />
          </MenuItem>
        ))}
      </StyledMenu>
    </Box>
  );
};

export default ActionMenuComponent;
